module.exports = __webpack_public_path__ + "static/media/front_01.90e23be1.png";